<script setup lang="ts">
import { ref, watch } from 'vue'
import { useNotification, VModal } from '@/shared/ui'
import { VDateInput } from 'vuetify/labs/VDateInput'
import { DateTime } from 'ts-luxon'
import './assets/style.scss'
import { formatLocalWallClockVerDateNow, useTranslate } from '@/shared/lib'

const emit = defineEmits<{
  (e: 'apply', verDate: string | undefined): void
}>()

const { trs } = useTranslate()
const $t = trs
const { addError } = useNotification()

// Управляем модалкой через модель "show", как и в VModal
const open = defineModel<boolean>('show', { default: false })
const dateInput = ref<string | null>(null)

watch(open, (v) => {
  if (v) dateInput.value = null
})

function toLocalTimestamp(value: string | null): string | null {
  if (!value) return null
  const parsedByDate = DateTime.fromJSDate(new Date(value))
  const parsedByISO = DateTime.fromISO(value)
  const pickedDate = parsedByDate.isValid ? parsedByDate : parsedByISO
  if (!pickedDate.isValid) return null

  const nowLocal = DateTime.local()
  return pickedDate
    .set({
      hour: nowLocal.hour,
      minute: nowLocal.minute,
      second: nowLocal.second,
      millisecond: 0,
    })
    .toFormat("yyyy-MM-dd'T'HH:mm:ss")
}

function applyHandler() {
  const value = dateInput.value
  if (!value) {
    emit('apply', formatLocalWallClockVerDateNow())
    open.value = false
    return
  }
  const iso = toLocalTimestamp(value)
  if (!iso) {
    addError(trs('itf.invalid_date_format'))
    return
  }
  emit('apply', iso)
  open.value = false
}

function closeHandler() {
  open.value = false
}
</script>

<template>
  <VModal v-model:show="open" :width="420">
    <template #title>
      {{ $t('itf.save') }}
    </template>

    <p class="v-passport-save-date-modal__text">
      {{ $t('itf.apply_changes_from_date') }}
    </p>

    <VDateInput
      v-model="dateInput"
      :label="$t('itf.date_placeholder_dmy')"
      :placeholder="$t('itf.date_placeholder_dmy')"
      variant="outlined"
      density="compact"
      clearable
      hide-details
      class="mt-2"
    />

    <div class="form__btn_right mt-4">
      <VBtn color="default" variant="tonal" @click="closeHandler">
        {{ $t('itf.cancel') }}
      </VBtn>
      <VBtn @click="applyHandler">
        {{ $t('itf.apply') }}
      </VBtn>
    </div>
  </VModal>
</template>

